// Vendor Imports
import _ from 'lodash';
// Project Imports
import { getGroupedCategoricalData } from './grouped-categorical-data-manager';
import { getUngroupedCategoricalData } from './ungrouped-categorical-data-manager';
// Constants
export const MAX_ROW_COUNT = 1000;

export function getCategoricalData(vif) {
  const isPieChart = _.some(vif.series, (series) => _.get(series, 'type', null) === 'pieChart');
  const isGrouping = !_.isNull(_.get(vif, 'series[0].dataSource.dimension.grouping.columnName', null));
  const options = {
    MAX_ROW_COUNT,
  };

  // Pie charts explicitly do not support grouping. We do this check here in
  // order to allow Bar, Column and Pie charts to all call this method and rely
  // on the right behavior in all cases.
  if (!isPieChart && isGrouping) {
    return getGroupedCategoricalData(vif, options);
  } else {
    return getUngroupedCategoricalData(vif, options);
  }
}
